var _circle, _circle2, _circle3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgDialogLimitPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 77.5,
    cy: 75.5,
    r: 70,
    stroke: "#89F3B8",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.34,
    cx: 77.5,
    cy: 75.5,
    r: 75,
    stroke: "#89F3B8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 77.5,
    cy: 75.5,
    r: 63.5,
    stroke: "#89F3B8",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 75.5C18 42.6391 44.6391 16 77.5 16C110.361 16 137 42.6391 137 75.5C137 108.361 110.361 135 77.5 135C44.6391 135 18 108.361 18 75.5Z",
    fill: "url(#paint0_linear_5660_136752)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.25 55.3125L77.4375 43.125L89.625 55.3125V59.375H81.5V63.4375V67.5H73.375V63.4375V59.375H65.25V55.3125ZM81.5 87.8125V89.8438V91.875H89.625V95.9375L77.4375 108.125L65.25 95.9375V91.875H73.375V89.8438V87.8125V83.75H81.5V87.8125ZM57.125 71.5625V79.6875H49V71.5625H57.125ZM61.1875 71.5625H69.3125V79.6875H61.1875V71.5625ZM81.5 71.5625V79.6875H73.375V71.5625H81.5ZM85.5625 71.5625H93.6875V79.6875H85.5625V71.5625ZM97.75 71.5625H105.875V79.6875H97.75V71.5625Z",
    fill: "url(#paint1_linear_5660_136752)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5660_136752",
    x1: 77.5,
    y1: 16,
    x2: 77.5,
    y2: 135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21E375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20B970"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5660_136752",
    x1: 68.1607,
    y1: 38.9375,
    x2: 68.1607,
    y2: 108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260076,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3FFD4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDialogLimitPower);
export default __webpack_public_path__ + "static/media/img_dialog_limit_power.1445e0e3ba2d8b16f8c3d335a544a0cc.svg";
export { ForwardRef as ReactComponent };